export const SUPPORTED_LOCALES = ['en', 'pt', 'de'] as const;
export const DEFAULT_LOCALE = 'en';

export const LOCALE_CONFIG = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
] as const;

export const LANDING_LOCALES = ['en', 'pt', 'de'] as const;
export const APP_LOCALES = ['en', 'pt', 'de'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];
export function isValidLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

// Blog/Docs locale constants
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  pt: 'Português',
  de: 'Deutsch',
};

export const LOCALE_FLAGS: Record<Locale, string> = {
  en: '🇬🇧',
  pt: '🇵🇹',
  de: '🇩🇪',
};
